<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="-1"> Todos </option>
    <option
      v-for="status in selects"
      :key="status.id"
      :value="status.id"
      :selected="status.id == selected"
      >{{ status.status }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectInvoiceValidationStatuses',
  data() {
    return {
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/invoice/validation/statuses`).then((res) => {
        this.selects = res.data.data;
      });
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
